export const ROUTES = {
  home: '/',
  news: 'news',
  notices: 'notices',
  friends: 'friends',
  register: 'register',
  login: 'login',
  user: 'user',
};

export const ROUTES_PARAMS = {
  categoryName: 'categoryName',
};

export const ROUTES_CATEGORY_NAMES = {
  sell: 'sell',
  lost_found: 'lost-found',
  for_free: 'for-free',
  favorite: 'favorite',
  own: 'own',
};
